import { render } from "./ViewBaseTable.vue?vue&type=template&id=70912863"
import script from "./ViewBaseTable.vue?vue&type=script&lang=js"
export * from "./ViewBaseTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__